// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports-menu {
  width: 300px;
  height: 100vh;
  background: var(--color-sidebar-bg);
  border-right: 1px solid var(--color-sidebar-border);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);
  z-index: 100;
  transition: all 0.3s ease;
  overflow-x: hidden;
}
.reports-menu.collapsed {
  width: 60px;
  overflow: visible;
}
.reports-menu.collapsed .reports-menu-items {
  overflow: visible;
}
.reports-menu.collapsed .reports-menu-controls {
  display: none;
}
.reports-menu.collapsed .reports-menu-header {
  display: none;
}
.reports-menu.collapsed .reports-menu-brand {
  display: none;
}
.reports-menu.collapsed .reports-sidebar-header {
  justify-content: center;
  padding: 10px 10px;
  flex-direction: column;
}
.reports-menu.collapsed .reports-sidebar-header .toggle-menu-icon {
  margin: 0 !important;
}
.reports-menu.collapsed .reports-sidebar-header .logo-collapsed {
  display: flex;
  justify-content: center;
  align-items: center;
}
.reports-menu.collapsed .reports-sidebar-header .logo-collapsed .company-logo-small {
  width: 45px;
  height: auto;
  object-fit: contain;
}
.reports-menu.collapsed .profile-section-bottom {
  padding: 10px;
  background: #1a2332;
  border-top: 1px solid #2d3748;
}
.reports-menu.collapsed .profile-section-bottom .profile-dropdown-container .profile-trigger {
  justify-content: center;
  padding: 0px 8px;
}
.reports-menu.collapsed .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-avatar {
  width: 44px;
  height: 44px;
}
.reports-menu.collapsed .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-avatar i {
  font-size: 1.3rem;
}
.reports-menu .menu-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid var(--color-sidebar-border);
}
.reports-menu .menu-expand-btn i {
  color: var(--color-menu-text);
  font-size: 0.9rem;
  transition: all 0.2s ease;
}
.reports-menu .menu-expand-btn:hover {
  background: var(--color-menu-hover-bg);
}
.reports-menu .menu-expand-btn:hover i {
  color: var(--color-primary-green);
}
.reports-menu .reports-sidebar-header {
  display: flex;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid var(--color-sidebar-border);
  background: var(--color-sidebar-bg);
}
.reports-menu .reports-sidebar-header .company-logo {
  width: 220px;
  height: auto;
  object-fit: contain;
}
.reports-menu .reports-sidebar-header .logo-text {
  color: var(--color-primary-green);
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}
.reports-menu .reports-sidebar-header .toggle-menu-icon {
  cursor: pointer;
  color: var(--color-menu-text);
  font-size: 1rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 5px;
}
.reports-menu .reports-sidebar-header .toggle-menu-icon:hover {
  color: var(--color-primary-green);
}
.reports-menu .reports-sidebar-header .toggle-menu-icon.centered {
  justify-content: center;
}
.reports-menu .reports-sidebar-header .toggle-menu-icon i {
  font-size: 1rem;
}
.reports-menu .reports-sidebar-header .logo-collapsed {
  display: none;
}
.reports-menu .reports-menu-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  border-bottom: 1px solid var(--color-sidebar-border);
  background: var(--color-sidebar-bg);
}
.reports-menu .reports-menu-brand .company-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.reports-menu .reports-menu-brand .company-name {
  margin: 0;
  color: var(--color-primary-green);
  font-size: 1.1rem;
  font-weight: 600;
  flex: 1 1;
}
.reports-menu .reports-menu-brand-collapsed {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid var(--color-sidebar-border);
}
.reports-menu .reports-menu-brand-collapsed .company-logo-small {
  width: 45px;
  height: 35px;
  object-fit: contain;
}
.reports-menu .reports-menu-header {
  padding: 20px 15px;
  border-bottom: 1px solid var(--color-sidebar-border);
  background: var(--color-sidebar-bg);
}
.reports-menu .reports-menu-header h5 {
  margin: 0;
  color: var(--color-menu-label);
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.reports-menu .profile-section-bottom {
  padding: 12px 15px;
  border-top: 1px solid #2d3748;
  background: #1a2332;
  margin-top: auto;
}
.reports-menu .profile-section-bottom .profile-dropdown-container {
  position: relative;
  cursor: pointer;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger:hover {
  background: #2d3748;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-avatar {
  width: 45px;
  height: 45px;
  background: var(--color-primary-green);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-avatar i {
  color: #1a2332;
  font-size: 1.3rem;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-info {
  flex: 1 1;
  min-width: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-info .profile-name {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-info .profile-role {
  margin: 3px 0 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-trigger .profile-chevron {
  color: #cbd5e1;
  font-size: 0.85rem;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  background: #1a2332;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header .profile-panel-avatar,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header .profile-panel-avatar {
  width: 50px;
  height: 50px;
  background: var(--color-primary-green);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header .profile-panel-avatar span,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header .profile-panel-avatar span {
  color: var(--color-text-dark);
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header .profile-panel-info,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header .profile-panel-info {
  flex: 1 1;
  min-width: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header .profile-panel-info .profile-panel-name,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header .profile-panel-info .profile-panel-name {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-panel-header .profile-panel-info .profile-panel-role,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-panel-header .profile-panel-info .profile-panel-role {
  margin: 4px 0 0 0;
  font-size: 0.8rem;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  margin: 0 15px 15px 0px;
  background: #2d3748;
  border: 1px solid #3d4758;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector:hover {
  background: #374151;
  border-color: #4b5563;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector i.fa-building,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector i.fa-building {
  color: #94a3b8;
  font-size: 0.95rem;
  flex-shrink: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-text,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-text {
  flex: 1 1;
  min-width: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-text span,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-text span {
  font-size: 0.85rem;
  color: #e2e8f0;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-chevron,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-chevron {
  color: #94a3b8;
  font-size: 0.75rem;
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-chevron.company-chevron-open,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-chevron.company-chevron-open {
  transform: rotate(180deg);
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: #faf7f2;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  padding: 10px;
  z-index: 1002;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn {
  cursor: pointer;
  font-size: 13px;
  padding: 6px 14px;
  border-radius: 16px;
  border: none;
  transition: all 0.2s ease;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-cancel,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-cancel {
  border: 1px solid #e0e0e0;
  background: transparent;
  color: #666666;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-cancel:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-cancel:hover {
  background: #f5f5f5;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-apply,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-apply {
  background: var(--color-primary-orange);
  color: #ffffff;
  font-weight: 500;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-apply:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-company-selector .company-dropdown-panel .company-dropdown-actions .company-btn.company-btn-apply:hover {
  background: #d97e2c;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons {
  display: flex;
  gap: 12px;
  padding: 15px 20px 20px 20px;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn {
  flex: 1 1;
  padding: 9px 24px;
  border-radius: 24px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  background: transparent;
  border: 2px solid #4a5568;
  color: #cbd5e1;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn:hover {
  border-color: #5a6678;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn.portal-btn-admin.active,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn.portal-btn-admin.active {
  background: transparent;
  border: 2px solid #d4a054;
  color: #d4a054;
  font-weight: 600;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn.portal-btn-admin.active:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn.portal-btn-admin.active:hover {
  border-color: #dba95f;
  color: #dba95f;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn.portal-btn-report.active,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn.portal-btn-report.active {
  background: transparent;
  border: 2px solid #d4a054;
  color: #d4a054;
  font-weight: 600;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-portal-buttons .portal-btn.portal-btn-report.active:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-portal-buttons .portal-btn.portal-btn-report.active:hover {
  border-color: #dba95f;
  color: #dba95f;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions {
  padding: 10px 0 0px 0;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions .profile-action-item,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions .profile-action-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  color: #e2e8f0;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions .profile-action-item i,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions .profile-action-item i {
  width: 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 1rem;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions .profile-action-item span,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions .profile-action-item span {
  flex: 1 1;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions .profile-action-item:hover,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions .profile-action-item:hover {
  background: #2d3748;
  color: #ffffff;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel .profile-actions .profile-action-item:hover i,
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed .profile-actions .profile-action-item:hover i {
  color: var(--color-primary-green);
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-dropdown-panel {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 8px;
  background: #1a2332;
  border: 1px solid #2d3748;
  border-radius: 12px;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  overflow: hidden;
  min-width: 300px;
}
.reports-menu .profile-section-bottom .profile-dropdown-container .profile-submenu-collapsed {
  position: absolute;
  bottom: 0;
  left: 100%;
  margin-left: 10px;
  min-width: 300px;
  background: #1a2332;
  border: 1px solid #2d3748;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  z-index: 1001;
  overflow: hidden;
}
.reports-menu .reports-menu-controls {
  padding: 15px;
  border-bottom: 1px solid var(--color-sidebar-border);
}
.reports-menu .reports-menu-controls .search-box {
  display: flex;
  align-items: center;
  background: var(--color-sidebar-bg);
  border: 1px solid var(--color-sidebar-border);
  border-radius: 6px;
  padding: 8px 12px;
  gap: 8px;
  transition: all 0.2s ease;
}
.reports-menu .reports-menu-controls .search-box:focus-within {
  border-color: var(--color-primary-green);
  background: var(--color-menu-active-bg);
}
.reports-menu .reports-menu-controls .search-box i {
  color: var(--color-menu-label);
  font-size: 0.9rem;
  flex-shrink: 0;
}
.reports-menu .reports-menu-controls .search-box input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: var(--color-menu-text);
  font-size: 16px !important;
  outline: none;
}
.reports-menu .reports-menu-controls .search-box input::placeholder {
  color: var(--color-menu-label);
}
.reports-menu .home-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin: 8px;
  border-radius: 6px;
  text-decoration: none;
  color: var(--color-menu-text);
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid var(--color-sidebar-border);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
.reports-menu .home-menu-item i {
  font-size: 1.1rem;
  min-width: 20px;
  text-align: center;
  color: var(--color-icon-slate);
  flex-shrink: 0;
}
.reports-menu .home-menu-item .report-name {
  font-size: 0.875rem;
  color: var(--color-menu-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .home-menu-item:hover {
    background: var(--color-menu-hover-bg);
    color: var(--color-menu-hover-text);
  }
  .reports-menu .home-menu-item:hover i, .reports-menu .home-menu-item:hover span {
    color: var(--color-primary-green);
  }
  .reports-menu .home-menu-item:hover .report-name {
    color: var(--color-primary-green);
  }
}
.reports-menu .home-menu-item.active {
  background: var(--color-menu-active-bg);
  color: var(--color-menu-active-text);
  border-left: 3px solid var(--color-menu-active-text);
}
.reports-menu .home-menu-item.active i, .reports-menu .home-menu-item.active span {
  color: var(--color-menu-active-text);
}
.reports-menu .home-menu-item.active .report-name {
  color: var(--color-menu-active-text);
}
.reports-menu .home-menu-item.active:hover {
  background: var(--color-menu-active-bg);
}
.reports-menu .reports-menu-items {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
  transition: opacity 0.3s ease;
}
.reports-menu .reports-menu-items .reports-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 4px;
  margin-bottom: 2px;
  border-radius: 6px;
  text-decoration: none;
  color: var(--color-menu-text);
  font-weight: 500;
  transition: all 0.2s ease;
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
@media (hover: none) or (pointer: coarse) {
  .reports-menu .reports-menu-items .reports-menu-item {
    padding-right: 4px;
  }
}
.reports-menu .reports-menu-items .reports-menu-item i {
  font-size: 1.1rem;
  min-width: 20px;
  text-align: center;
  color: var(--color-icon-slate);
  flex-shrink: 0;
  pointer-events: none;
}
.reports-menu .reports-menu-items .reports-menu-item .report-name {
  font-size: 0.875rem;
  color: var(--color-menu-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  pointer-events: none;
}
@media (hover: none) or (pointer: coarse) {
  .reports-menu .reports-menu-items .reports-menu-item .report-name {
    margin-right: 4px;
  }
}
.reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn {
  background: transparent;
  border: none;
  padding: 4px 4px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
  margin-left: auto;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  position: relative;
  z-index: 2;
  flex-shrink: 0;
}
.reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn i {
  font-size: 0.95rem;
  color: var(--color-menu-text);
  min-width: auto;
  pointer-events: none;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn:hover {
    background: rgba(209, 172, 114, 0.1);
    opacity: 1;
  }
  .reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn:hover i {
    color: var(--color-primary-green);
  }
}
@media (hover: none) or (pointer: coarse) {
  .reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn {
    opacity: 1;
    min-width: 30px;
    min-height: 30px;
    padding: 4px;
    margin-right: -4px;
    margin-left: 8px;
    border-left: 1px solid rgba(209, 172, 114, 0.2);
  }
  .reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn i {
    font-size: 1rem;
  }
}
.reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn.favorite-active {
  opacity: 1;
}
.reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn.favorite-active i {
  color: #faca00;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn.favorite-active:hover {
    background: rgba(209, 172, 114, 0.2);
  }
}
.reports-menu .reports-menu-items .reports-menu-item .favorite-icon-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .reports-menu-items .reports-menu-item:hover .favorite-icon-btn {
    opacity: 1;
  }
}
.reports-menu .reports-menu-items .reports-menu-item span {
  font-size: 0.875rem;
  color: var(--color-menu-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .reports-menu-items .reports-menu-item:hover {
    background: var(--color-menu-hover-bg);
    color: var(--color-menu-hover-text);
  }
  .reports-menu .reports-menu-items .reports-menu-item:hover i, .reports-menu .reports-menu-items .reports-menu-item:hover span {
    color: var(--color-primary-green);
  }
  .reports-menu .reports-menu-items .reports-menu-item:hover .report-name {
    color: var(--color-primary-green);
  }
}
.reports-menu .reports-menu-items .reports-menu-item.active {
  background: var(--color-menu-active-bg);
  color: var(--color-menu-active-text);
  border-left: 3px solid var(--color-menu-active-text);
}
.reports-menu .reports-menu-items .reports-menu-item.active i, .reports-menu .reports-menu-items .reports-menu-item.active span {
  color: var(--color-menu-active-text);
}
.reports-menu .reports-menu-items .reports-menu-item.active .report-name {
  color: var(--color-menu-active-text);
}
.reports-menu .reports-menu-items .reports-menu-item.active:hover {
  background: var(--color-menu-active-bg);
}
.reports-menu .reports-menu-items .reports-menu-item.has-pages .report-menu-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
}
.reports-menu .reports-menu-items .reports-menu-item.has-pages .expand-icon-btn {
  background: transparent;
  border: none;
  padding: 4px 4px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
.reports-menu .reports-menu-items .reports-menu-item.has-pages .expand-icon-btn i {
  font-size: 0.85rem;
  color: var(--color-menu-text);
  min-width: auto;
}
.reports-menu .reports-menu-items .reports-menu-item.has-pages .expand-icon-btn:hover {
  background: rgba(209, 172, 114, 0.1);
}
.reports-menu .reports-menu-items .reports-menu-item.has-pages .expand-icon-btn:hover i {
  color: var(--color-primary-green);
}
.reports-menu .reports-menu-items .report-with-pages {
  margin-bottom: 4px;
}
.reports-menu .reports-menu-items .report-pages-list {
  padding-left: 20px;
  margin-top: 2px;
  margin-bottom: 4px;
  border-left: 2px solid rgba(209, 172, 114, 0.2);
  margin-left: 20px;
}
.reports-menu .reports-menu-items .report-pages-list .report-page-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}
.reports-menu .reports-menu-items .report-pages-list .report-page-item i {
  font-size: 0.9rem;
  min-width: 16px;
  text-align: center;
  color: #94a3b8;
  flex-shrink: 0;
}
.reports-menu .reports-menu-items .report-pages-list .report-page-item .page-name {
  font-size: 0.82rem;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
}
@media (hover: hover) and (pointer: fine) {
  .reports-menu .reports-menu-items .report-pages-list .report-page-item:hover {
    background: rgba(209, 172, 114, 0.1);
  }
  .reports-menu .reports-menu-items .report-pages-list .report-page-item:hover i, .reports-menu .reports-menu-items .report-pages-list .report-page-item:hover .page-name {
    color: var(--color-primary-green);
  }
}
.reports-menu .reports-menu-items .report-pages-list .report-page-item.active {
  background: rgba(209, 172, 114, 0.15);
}
.reports-menu .reports-menu-items .report-pages-list .report-page-item.active i, .reports-menu .reports-menu-items .report-pages-list .report-page-item.active .page-name {
  color: var(--color-primary-green);
  font-weight: 600;
}
.reports-menu.collapsed .home-menu-item {
  justify-content: center;
  padding: 8px 8px;
  margin: 5px 5px;
  border-left: none;
  position: relative;
}
.reports-menu.collapsed .home-menu-item:hover {
  transform: none;
  background: var(--color-menu-hover-bg);
}
.reports-menu.collapsed .home-menu-item i {
  font-size: 1.3rem;
  margin: 0;
}
.reports-menu.collapsed .home-menu-item span:not(.tooltip-text) {
  display: none;
}
.reports-menu.collapsed .home-menu-item .tooltip-text {
  display: block;
}
.reports-menu.collapsed .home-menu-item.active {
  background: var(--color-menu-active-bg);
  border-left: 3px solid var(--color-menu-active-text);
}
.reports-menu.collapsed .home-menu-item.active i {
  color: var(--color-menu-active-text);
}
.reports-menu.collapsed .reports-menu-items {
  padding: 10px 5px;
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: auto !important;
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item {
  justify-content: center;
  padding: 12px 8px;
  margin-bottom: 8px;
  border-left: none;
  position: relative;
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item:hover {
  transform: none;
  background: var(--color-menu-hover-bg);
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item i {
  font-size: 1.3rem;
  margin: 0;
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item > span:not(.tooltip-text) {
  display: none;
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item.active {
  background: var(--color-menu-active-bg);
  border-left: 3px solid var(--color-menu-active-text);
}
.reports-menu.collapsed .reports-menu-items .reports-menu-item.active i {
  color: var(--color-menu-active-text);
}
.reports-menu.collapsed .reports-menu-items .report-pages-list {
  display: none !important;
}
.reports-menu.collapsed .reports-menu-items .report-with-pages .expand-icon-btn {
  display: none !important;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 200px;
  background: var(--color-sidebar-bg);
  border: 1px solid var(--color-sidebar-border);
  border-radius: 6px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1100;
  margin-left: 0;
  overflow: hidden;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout::before {
  content: "";
  position: absolute;
  right: 100%;
  top: 0;
  width: 10px;
  height: 100%;
  background: transparent;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-header {
  padding: 10px 16px;
  background: transparent;
  border-bottom: 1px solid rgba(209, 172, 114, 0.15);
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--color-primary-green);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-pages {
  max-height: 400px;
  overflow-y: auto;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-pages::-webkit-scrollbar {
  width: 6px;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-pages::-webkit-scrollbar-track {
  background: var(--color-sidebar-bg);
  border-radius: 10px;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-pages::-webkit-scrollbar-thumb {
  background: var(--color-primary-green);
  border-radius: 10px;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-pages::-webkit-scrollbar-thumb:hover {
  background: var(--color-primary-orange);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--color-menu-text);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item i {
  font-size: 0.9rem;
  color: #94a3b8;
  min-width: 16px;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item span {
  font-size: 0.875rem;
  white-space: nowrap;
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item:hover {
  background: var(--color-menu-hover-bg);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item:hover i, .reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item:hover span {
  color: var(--color-primary-green);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item.active {
  background: rgba(209, 172, 114, 0.15);
}
.reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item.active i, .reports-menu.collapsed .reports-menu-items .report-submenu-flyout .submenu-page-item.active span {
  color: var(--color-primary-green);
  font-weight: 600;
}
.reports-menu.collapsed .reports-menu-items .report-with-pages:hover .report-submenu-flyout {
  display: block;
}
.reports-menu .favorites-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--color-sidebar-border);
}
.reports-menu .favorites-section .favorites-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 10px;
  color: var(--color-menu-label);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.reports-menu .favorites-section .favorites-header i {
  color: var(--color-primary-green);
  font-size: 0.875rem;
}
.reports-menu .favorites-section .favorites-header .favorites-count {
  margin-left: auto;
  background: var(--color-sidebar-border);
  color: var(--color-menu-text);
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
}
.reports-menu .favorites-section .favorite-report-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 8px;
  background: var(--color-sidebar-bg);
  border: 1px solid var(--color-sidebar-border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.reports-menu .favorites-section .favorite-report-card:hover {
  background: var(--color-menu-hover-bg);
  border-color: var(--color-primary-green);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(209, 172, 114, 0.15);
}
.reports-menu .favorites-section .favorite-report-card.active {
  background: var(--color-menu-active-bg);
  border-color: var(--color-primary-green);
  border-left: 3px solid var(--color-menu-active-text);
}
.reports-menu .favorites-section .favorite-report-card.active .favorite-report-name {
  color: var(--color-menu-active-text);
}
.reports-menu .favorites-section .favorite-report-card .favorite-report-icon {
  width: 40px;
  height: 40px;
  background: var(--color-primary-green);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.reports-menu .favorites-section .favorite-report-card .favorite-report-icon i {
  color: var(--color-text-dark);
  font-size: 1.1rem;
}
.reports-menu .favorites-section .favorite-report-card .favorite-report-info {
  flex: 1 1;
  min-width: 0;
}
.reports-menu .favorites-section .favorite-report-card .favorite-report-info .favorite-report-name {
  margin: 0 0 4px 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-menu-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .favorites-section .favorite-report-card .favorite-report-info .favorite-report-description {
  margin: 0;
  font-size: 0.75rem;
  color: var(--color-menu-label);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.reports-menu .favorites-section .favorite-report-card .favorite-star {
  flex-shrink: 0;
}
.reports-menu .favorites-section .favorite-report-card .favorite-star i {
  color: var(--color-primary-green);
  font-size: 1rem;
}
.reports-menu .all-reports-header {
  padding: 10px 12px;
  margin-bottom: 5px;
  color: var(--color-menu-label);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}
.reports-menu .reports-menu-items::-webkit-scrollbar {
  width: 6px;
}
.reports-menu .reports-menu-items::-webkit-scrollbar-track {
  background: var(--color-sidebar-bg);
  border-radius: 10px;
}
.reports-menu .reports-menu-items::-webkit-scrollbar-thumb {
  background: var(--color-primary-green);
  border-radius: 10px;
}
.reports-menu .reports-menu-items::-webkit-scrollbar-thumb:hover {
  background: var(--color-primary-orange);
}

@media (max-width: 768px) {
  .reports-menu {
    width: 100% !important;
    height: calc(100vh - 55px);
    position: fixed !important;
    top: 45px !important;
    left: 0 !important;
    max-height: calc(100vh - 55px);
    overflow: hidden;
    border-right: none;
    border-bottom: none;
    z-index: 1000;
    padding-top: 0 !important;
    box-shadow: none;
    display: flex;
    flex-direction: column;
  }
  .reports-menu.collapsed {
    display: none !important;
  }
  .reports-menu .reports-menu-brand {
    padding: 10px;
    flex-shrink: 0;
  }
  .reports-menu .reports-menu-brand .company-logo {
    width: 30px;
    height: 30px;
  }
  .reports-menu .reports-menu-brand .company-name {
    font-size: 0.9rem;
  }
  .reports-menu .reports-menu-header {
    padding: 10px 15px;
    flex-shrink: 0;
  }
  .reports-menu .reports-menu-header h5 {
    font-size: 0.65rem;
  }
  .reports-menu .reports-menu-controls {
    padding: 10px;
    flex-shrink: 0;
  }
  .reports-menu .reports-menu-controls .search-box {
    padding: 6px 10px;
    font-size: 0.8rem;
  }
  .reports-menu .reports-menu-items {
    padding: 5px;
    padding-bottom: 20px;
    flex: 1 1 auto;
    overflow-y: auto !important;
    min-height: 0;
    max-height: none !important;
    -webkit-overflow-scrolling: touch;
  }
  .reports-menu .reports-menu-items .reports-menu-item {
    padding: 10px;
    font-size: 0.9rem;
    flex-shrink: 0;
  }
  .reports-menu .reports-menu-items .reports-menu-item i {
    font-size: 1.1rem;
  }
  .reports-menu .reports-menu-items .report-pages-list {
    max-height: none;
    flex-shrink: 0;
  }
  .profile-section-bottom {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/power-bi-portal/components/ReportsMenu.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,wCAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,iBAAA;AACJ;AACI;EACE,iBAAA;AACN;AAEI;EACE,aAAA;AAAN;AAGI;EACE,aAAA;AADN;AAII;EACE,aAAA;AAFN;AAKI;EACE,uBAAA;EACA,kBAAA;EACA,sBAAA;AAHN;AAKM;EACE,oBAAA;AAHR;AAMM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAMQ;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAJV;AASI;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AAPN;AAUQ;EACE,uBAAA;EACA,gBAAA;AARV;AAUU;EACE,WAAA;EACA,YAAA;AARZ;AAUY;EACE,iBAAA;AARd;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,oDAAA;AAfJ;AAiBI;EACE,6BAAA;EACA,iBAAA;EACA,yBAAA;AAfN;AAkBI;EACE,sCAAA;AAhBN;AAkBM;EACE,iCAAA;AAhBR;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,oDAAA;EACA,mCAAA;AAnBJ;AAqBI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAnBN;AAsBI;EACE,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AApBN;AAuBI;EACE,eAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AArBN;AAuBM;EACE,iCAAA;AArBR;AAwBM;EACE,uBAAA;AAtBR;AAyBM;EACE,eAAA;AAvBR;AA2BI;EACE,aAAA;AAzBN;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,oDAAA;EACA,mCAAA;AA3BJ;AA6BI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA3BN;AA8BI;EACE,SAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AA5BN;AAgCE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,oDAAA;AA9BJ;AAgCI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA9BN;AAkCE;EACE,kBAAA;EACA,oDAAA;EACA,mCAAA;AAhCJ;AAkCI;EACE,SAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AAhCN;AAoCE;EACE,kBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;AAlCJ;AAoCI;EACE,kBAAA;EACA,eAAA;AAlCN;AAoCM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAlCR;AAoCQ;EACE,mBAAA;AAlCV;AAqCQ;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAnCV;AAqCU;EACE,cAAA;EACA,iBAAA;AAnCZ;AAuCQ;EACE,SAAA;EACA,YAAA;AArCV;AAuCU;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArCZ;AAwCU;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtCZ;AA0CQ;EACE,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;AAxCV;AA+CQ;;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AA5CV;AA8CU;;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA3CZ;AA6CY;;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AA1Cd;AA8CU;;EACE,SAAA;EACA,YAAA;AA3CZ;AA6CY;;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1Cd;AA6CY;;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1Cd;AA+CQ;;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AA5CV;AA8CU;;EACE,mBAAA;EACA,qBAAA;AA3CZ;AA8CU;;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AA3CZ;AA8CU;;EACE,SAAA;EACA,YAAA;AA3CZ;AA6CY;;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AA1Cd;AA8CU;;EACE,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;AA3CZ;AA6CY;;EACE,yBAAA;AA1Cd;AA8CU;;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,aAAA;AA3CZ;AA6CY;;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;AA1Cd;AA4Cc;;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AAzChB;AA2CgB;;EACE,yBAAA;EACA,uBAAA;EACA,cAAA;AAxClB;AA0CkB;;EACE,mBAAA;AAvCpB;AA2CgB;;EACE,uCAAA;EACA,cAAA;EACA,gBAAA;AAxClB;AA0CkB;;EACE,mBAAA;AAvCpB;AA+CQ;;EACE,aAAA;EACA,SAAA;EACA,4BAAA;AA5CV;AA8CU;;EACE,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AA3CZ;AA6CY;;EACE,qBAAA;AA1Cd;AA8Cc;;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AA3ChB;AA6CgB;;EACE,qBAAA;EACA,cAAA;AA1ClB;AAgDc;;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AA7ChB;AA+CgB;;EACE,qBAAA;EACA,cAAA;AA5ClB;AAmDQ;;EACE,qBAAA;AAhDV;AAkDU;;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AA/CZ;AAiDY;;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA9Cd;AAiDY;;EACE,SAAA;AA9Cd;AAiDY;;EACE,mBAAA;EACA,cAAA;AA9Cd;AAgDc;;EACE,iCAAA;AA7ChB;AAqDM;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;AAnDR;AAuDM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,yCAAA;EACA,aAAA;EACA,gBAAA;AArDR;AA0DE;EACE,aAAA;EACA,oDAAA;AAxDJ;AA0DI;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,6CAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,yBAAA;AAxDN;AA0DM;EACE,wCAAA;EACA,uCAAA;AAxDR;AA2DM;EACE,8BAAA;EACA,iBAAA;EACA,cAAA;AAzDR;AA4DM;EACE,SAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,aAAA;AA1DR;AA4DQ;EACE,8BAAA;AA1DV;AAiEE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,oDAAA;EACA,wCAAA;EACA,0BAAA;AA/DJ;AAiEI;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;AA/DN;AAkEI;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAhEN;AAoEI;EACE;IACE,sCAAA;IACA,mCAAA;EAlEN;EAoEM;IACE,iCAAA;EAlER;EAqEM;IACE,iCAAA;EAnER;AACF;AAuEI;EACE,uCAAA;EACA,oCAAA;EACA,oDAAA;AArEN;AAuEM;EACE,oCAAA;AArER;AAwEM;EACE,oCAAA;AAtER;AAyEM;EACE,uCAAA;AAvER;AA4EE;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,6BAAA;AA1EJ;AA4EI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;AA1EN;AA6EM;EAjBF;IAkBI,kBAAA;EA1EN;AACF;AA4EM;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,cAAA;EACA,oBAAA;AA1ER;AA6EM;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AA3ER;AA6EQ;EATF;IAUI,iBAAA;EA1ER;AACF;AA6EM;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,wCAAA;EACA,0BAAA;EAEA,kBAAA;EACA,UAAA;EACA,cAAA;AA5ER;AA8EQ;EACE,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,oBAAA;AA5EV;AAgFQ;EACE;IACE,oCAAA;IACA,UAAA;EA9EV;EAgFU;IACE,iCAAA;EA9EZ;AACF;AAmFQ;EAvCF;IAwCI,UAAA;IACA,eAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,+CAAA;EAhFR;EAkFQ;IACE,eAAA;EAhFV;AACF;AAmFQ;EACE,UAAA;AAjFV;AAmFU;EACE,cAAA;AAjFZ;AAoFU;EACE;IACE,oCAAA;EAlFZ;AACF;AAsFQ;EACE,mBAAA;EACA,YAAA;AApFV;AAyFM;EACE;IACE,UAAA;EAvFR;AACF;AA0FM;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxFR;AA4FM;EACE;IACE,sCAAA;IACA,mCAAA;EA1FR;EA4FQ;IACE,iCAAA;EA1FV;EA6FQ;IACE,iCAAA;EA3FV;AACF;AA+FM;EACE,uCAAA;EACA,oCAAA;EACA,oDAAA;AA7FR;AA+FQ;EACE,oCAAA;AA7FV;AAgGQ;EACE,oCAAA;AA9FV;AAiGQ;EACE,uCAAA;AA/FV;AAqGQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AAnGV;AAsGQ;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wCAAA;EACA,0BAAA;AApGV;AAsGU;EACE,kBAAA;EACA,6BAAA;EACA,eAAA;AApGZ;AAuGU;EACE,oCAAA;AArGZ;AAuGY;EACE,iCAAA;AArGd;AA6GI;EACE,kBAAA;AA3GN;AA+GI;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;AA7GN;AA+GM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;EACA,0BAAA;AA7GR;AA+GQ;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AA7GV;AAgHQ;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AA9GV;AAiHQ;EACE;IACE,oCAAA;EA/GV;EAiHU;IACE,iCAAA;EA/GZ;AACF;AAmHQ;EACE,qCAAA;AAjHV;AAmHU;EACE,iCAAA;EACA,gBAAA;AAjHZ;AA0HI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAxHN;AA0HM;EACE,eAAA;EACA,sCAAA;AAxHR;AA2HM;EACE,iBAAA;EACA,SAAA;AAzHR;AA4HM;EACE,aAAA;AA1HR;AA6HM;EACE,cAAA;AA3HR;AA8HM;EACE,uCAAA;EACA,oDAAA;AA5HR;AA8HQ;EACE,oCAAA;AA5HV;AAiII;EACE,iBAAA;EACA,qBAAA;EACA,8BAAA;EACA,+BAAA;AA/HN;AAiIM;EACE,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA/HR;AAiIQ;EACE,eAAA;EACA,sCAAA;AA/HV;AAkIQ;EACE,iBAAA;EACA,SAAA;AAhIV;AAoIQ;EACE,aAAA;AAlIV;AAqIQ;EACE,uCAAA;EACA,oDAAA;AAnIV;AAqIU;EACE,oCAAA;AAnIZ;AAyIM;EACE,wBAAA;AAvIR;AA4IQ;EACE,wBAAA;AA1IV;AA+IM;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,gBAAA;EACA,mCAAA;EACA,6CAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AA7IR;AAgJQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AA9IV;AAiJQ;EACE,kBAAA;EACA,uBAAA;EACA,kDAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AA/IV;AAkJQ;EACE,iBAAA;EACA,gBAAA;AAhJV;AAmJU;EACE,UAAA;AAjJZ;AAoJU;EACE,mCAAA;EACA,mBAAA;AAlJZ;AAqJU;EACE,sCAAA;EACA,mBAAA;AAnJZ;AAqJY;EACE,uCAAA;AAnJd;AAwJQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,6BAAA;AAtJV;AAwJU;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAtJZ;AAyJU;EACE,mBAAA;EACA,mBAAA;AAvJZ;AA0JU;EACE,sCAAA;AAxJZ;AA0JY;EACE,iCAAA;AAxJd;AA4JU;EACE,qCAAA;AA1JZ;AA4JY;EACE,iCAAA;EACA,gBAAA;AA1Jd;AAkKQ;EACE,cAAA;AAhKV;AAsKE;EACE,mBAAA;EACA,oBAAA;EACA,oDAAA;AApKJ;AAsKI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AApKN;AAsKM;EACE,iCAAA;EACA,mBAAA;AApKR;AAuKM;EACE,iBAAA;EACA,uCAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AArKR;AAyKI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAvKN;AAyKM;EACE,sCAAA;EACA,wCAAA;EACA,2BAAA;EACA,+CAAA;AAvKR;AA0KM;EACE,uCAAA;EACA,wCAAA;EACA,oDAAA;AAxKR;AA0KQ;EACE,oCAAA;AAxKV;AA4KM;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA1KR;AA4KQ;EACE,6BAAA;EACA,iBAAA;AA1KV;AA8KM;EACE,SAAA;EACA,YAAA;AA5KR;AA8KQ;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5KV;AA+KQ;EACE,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7KV;AAiLM;EACE,cAAA;AA/KR;AAiLQ;EACE,iCAAA;EACA,eAAA;AA/KV;AAqLE;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAnLJ;AAsLE;EACE,UAAA;AApLJ;AAuLE;EACE,mCAAA;EACA,mBAAA;AArLJ;AAwLE;EACE,sCAAA;EACA,mBAAA;AAtLJ;AAwLI;EACE,uCAAA;AAtLN;;AA2LA;EACE;IACE,sBAAA;IACA,0BAAA;IACA,0BAAA;IACA,oBAAA;IACA,kBAAA;IACA,8BAAA;IACA,gBAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,yBAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;EAxLF;EA0LE;IACE,wBAAA;EAxLJ;EA2LE;IACE,aAAA;IACA,cAAA;EAzLJ;EA2LI;IACE,WAAA;IACA,YAAA;EAzLN;EA4LI;IACE,iBAAA;EA1LN;EA8LE;IACE,kBAAA;IACA,cAAA;EA5LJ;EA8LI;IACE,kBAAA;EA5LN;EAgME;IACE,aAAA;IACA,cAAA;EA9LJ;EAgMI;IACE,iBAAA;IACA,iBAAA;EA9LN;EAkME;IACE,YAAA;IACA,oBAAA;IACA,cAAA;IACA,2BAAA;IACA,aAAA;IACA,2BAAA;IACA,iCAAA;EAhMJ;EAkMI;IACE,aAAA;IACA,iBAAA;IACA,cAAA;EAhMN;EAkMM;IACE,iBAAA;EAhMR;EAqMI;IACE,gBAAA;IACA,cAAA;EAnMN;EAuMA;IACE,aAAA;EArMF;AACF","sourcesContent":[".reports-menu {\n  width: 300px;\n  height: 100vh;\n  background: var(--color-sidebar-bg);\n  border-right: 1px solid var(--color-sidebar-border);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3);\n  z-index: 100;\n  transition: all 0.3s ease;\n  overflow-x: hidden;\n\n  &.collapsed {\n    width: 60px;\n    overflow: visible;\n\n    .reports-menu-items {\n      overflow: visible;\n    }\n\n    .reports-menu-controls {\n      display: none;\n    }\n\n    .reports-menu-header {\n      display: none;\n    }\n\n    .reports-menu-brand {\n      display: none;\n    }\n\n    .reports-sidebar-header {\n      justify-content: center;\n      padding: 10px 10px;\n      flex-direction: column;\n\n      .toggle-menu-icon {\n        margin: 0 !important;\n      }\n\n      .logo-collapsed {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .company-logo-small {\n          width: 45px;\n          height: auto;\n          object-fit: contain;\n        }\n      }\n    }\n\n    .profile-section-bottom {\n      padding: 10px;\n      background: #1a2332;\n      border-top: 1px solid #2d3748;\n\n      .profile-dropdown-container {\n        .profile-trigger {\n          justify-content: center;\n          padding: 0px 8px;\n\n          .profile-avatar {\n            width: 44px;\n            height: 44px;\n\n            i {\n              font-size: 1.3rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // Expand button in collapsed state - below logo, above reports\n  .menu-expand-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border-bottom: 1px solid var(--color-sidebar-border);\n\n    i {\n      color: var(--color-menu-text);\n      font-size: 0.9rem;\n      transition: all 0.2s ease;\n    }\n\n    &:hover {\n      background: var(--color-menu-hover-bg);\n\n      i {\n        color: var(--color-primary-green);\n      }\n    }\n  }\n\n  .reports-sidebar-header {\n    display: flex;\n    align-items: center;\n    padding: 5px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n    background: var(--color-sidebar-bg);\n\n    .company-logo {\n      width: 220px;\n      height: auto;\n      object-fit: contain;\n    }\n\n    .logo-text {\n      color: var(--color-primary-green);\n      font-size: 1.1rem;\n      font-weight: 600;\n      margin: 0;\n      white-space: nowrap;\n    }\n\n    .toggle-menu-icon {\n      cursor: pointer;\n      color: var(--color-menu-text);\n      font-size: 1rem;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      padding: 5px;\n\n      &:hover {\n        color: var(--color-primary-green);\n      }\n\n      &.centered {\n        justify-content: center;\n      }\n\n      i {\n        font-size: 1rem;\n      }\n    }\n\n    .logo-collapsed {\n      display: none;\n    }\n  }\n\n  .reports-menu-brand {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 15px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n    background: var(--color-sidebar-bg);\n\n    .company-logo {\n      width: 40px;\n      height: 40px;\n      object-fit: contain;\n    }\n\n    .company-name {\n      margin: 0;\n      color: var(--color-primary-green);\n      font-size: 1.1rem;\n      font-weight: 600;\n      flex: 1;\n    }\n  }\n\n  .reports-menu-brand-collapsed {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n\n    .company-logo-small {\n      width: 45px;\n      height: 35px;\n      object-fit: contain;\n    }\n  }\n\n  .reports-menu-header {\n    padding: 20px 15px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n    background: var(--color-sidebar-bg);\n\n    h5 {\n      margin: 0;\n      color: var(--color-menu-label);\n      font-weight: 600;\n      font-size: 0.75rem;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n    }\n  }\n\n  .profile-section-bottom {\n    padding: 12px 15px;\n    border-top: 1px solid #2d3748;\n    background: #1a2332;\n    margin-top: auto;\n\n    .profile-dropdown-container {\n      position: relative;\n      cursor: pointer;\n\n      .profile-trigger {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        padding: 8px;\n        border-radius: 8px;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background: #2d3748;\n        }\n\n        .profile-avatar {\n          width: 45px;\n          height: 45px;\n          background: var(--color-primary-green);\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex-shrink: 0;\n\n          i {\n            color: #1a2332;\n            font-size: 1.3rem;\n          }\n        }\n\n        .profile-info {\n          flex: 1;\n          min-width: 0;\n\n          .profile-name {\n            margin: 0;\n            font-size: 0.95rem;\n            font-weight: 600;\n            color: #ffffff;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n\n          .profile-role {\n            margin: 3px 0 0 0;\n            font-size: 0.8rem;\n            color: #94a3b8;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n\n        .profile-chevron {\n          color: #cbd5e1;\n          font-size: 0.85rem;\n          transition: transform 0.2s ease;\n          flex-shrink: 0;\n        }\n      }\n\n      // Shared styles for both dropdown and collapsed submenu\n      .profile-dropdown-panel,\n      .profile-submenu-collapsed {\n        .profile-panel-header {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          padding: 10px;\n          background: #1a2332;\n\n          .profile-panel-avatar {\n            width: 50px;\n            height: 50px;\n            background: var(--color-primary-green);\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n\n            span {\n              color: var(--color-text-dark);\n              font-size: 1.1rem;\n              font-weight: 700;\n              text-transform: uppercase;\n            }\n          }\n\n          .profile-panel-info {\n            flex: 1;\n            min-width: 0;\n\n            .profile-panel-name {\n              margin: 0;\n              font-size: 1rem;\n              font-weight: 600;\n              color: #ffffff;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n\n            .profile-panel-role {\n              margin: 4px 0 0 0;\n              font-size: 0.8rem;\n              color: #94a3b8;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }\n          }\n        }\n\n        .profile-company-selector {\n          position: relative;\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          padding: 12px 15px;\n          margin: 0 15px 15px 0px;\n          background: #2d3748;\n          border: 1px solid #3d4758;\n          border-radius: 8px;\n          cursor: pointer;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: #374151;\n            border-color: #4b5563;\n          }\n\n          i.fa-building {\n            color: #94a3b8;\n            font-size: 0.95rem;\n            flex-shrink: 0;\n          }\n\n          .company-text {\n            flex: 1;\n            min-width: 0;\n\n            span {\n              font-size: 0.85rem;\n              color: #e2e8f0;\n              font-weight: 500;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              display: block;\n            }\n          }\n\n          .company-chevron {\n            color: #94a3b8;\n            font-size: 0.75rem;\n            transition: transform 0.2s ease;\n            flex-shrink: 0;\n\n            &.company-chevron-open {\n              transform: rotate(180deg);\n            }\n          }\n\n          .company-dropdown-panel {\n            position: absolute;\n            top: calc(100% + 8px);\n            left: 0;\n            right: 0;\n            background: #faf7f2;\n            border: 1px solid rgba(0, 0, 0, 0.08);\n            border-radius: 10px;\n            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n            padding: 10px;\n            z-index: 1002;\n\n            .company-dropdown-actions {\n              display: flex;\n              justify-content: flex-end;\n              gap: 8px;\n              margin-top: 10px;\n\n              .company-btn {\n                cursor: pointer;\n                font-size: 13px;\n                padding: 6px 14px;\n                border-radius: 16px;\n                border: none;\n                transition: all 0.2s ease;\n\n                &.company-btn-cancel {\n                  border: 1px solid #e0e0e0;\n                  background: transparent;\n                  color: #666666;\n\n                  &:hover {\n                    background: #f5f5f5;\n                  }\n                }\n\n                &.company-btn-apply {\n                  background: var(--color-primary-orange);\n                  color: #ffffff;\n                  font-weight: 500;\n\n                  &:hover {\n                    background: #d97e2c;\n                  }\n                }\n              }\n            }\n          }\n        }\n\n        .profile-portal-buttons {\n          display: flex;\n          gap: 12px;\n          padding: 15px 20px 20px 20px;\n\n          .portal-btn {\n            flex: 1;\n            padding: 9px 24px;\n            border-radius: 24px;\n            font-size: 0.875rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.2s ease;\n            white-space: nowrap;\n            background: transparent;\n            border: 2px solid #4a5568;\n            color: #cbd5e1;\n\n            &:hover {\n              border-color: #5a6678;\n            }\n\n            &.portal-btn-admin {\n              &.active {\n                background: transparent;\n                border: 2px solid #d4a054;\n                color: #d4a054;\n                font-weight: 600;\n\n                &:hover {\n                  border-color: #dba95f;\n                  color: #dba95f;\n                }\n              }\n            }\n\n            &.portal-btn-report {\n              &.active {\n                background: transparent;\n                border: 2px solid #d4a054;\n                color: #d4a054;\n                font-weight: 600;\n\n                &:hover {\n                  border-color: #dba95f;\n                  color: #dba95f;\n                }\n              }\n            }\n          }\n        }\n\n        .profile-actions {\n          padding: 10px 0 0px 0;\n\n          .profile-action-item {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 10px 20px;\n            color: #e2e8f0;\n            font-size: 0.9rem;\n            font-weight: 500;\n            transition: all 0.2s ease;\n            cursor: pointer;\n\n            i {\n              width: 20px;\n              text-align: center;\n              color: #94a3b8;\n              font-size: 1rem;\n            }\n\n            span {\n              flex: 1;\n            }\n\n            &:hover {\n              background: #2d3748;\n              color: #ffffff;\n\n              i {\n                color: var(--color-primary-green);\n              }\n            }\n          }\n        }\n      }\n\n      // Specific positioning for dropdown panel\n      .profile-dropdown-panel {\n        position: absolute;\n        bottom: 100%;\n        left: 0;\n        right: 0;\n        margin-bottom: 8px;\n        background: #1a2332;\n        border: 1px solid #2d3748;\n        border-radius: 12px;\n        box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.3);\n        z-index: 1000;\n        overflow: hidden;\n        min-width: 300px;\n      }\n\n      // Specific positioning for collapsed menu submenu (click)\n      .profile-submenu-collapsed {\n        position: absolute;\n        bottom: 0;\n        left: 100%;\n        margin-left: 10px;\n        min-width: 300px;\n        background: #1a2332;\n        border: 1px solid #2d3748;\n        border-radius: 12px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n        z-index: 1001;\n        overflow: hidden;\n      }\n    }\n  }\n\n  .reports-menu-controls {\n    padding: 15px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n\n    .search-box {\n      display: flex;\n      align-items: center;\n      background: var(--color-sidebar-bg);\n      border: 1px solid var(--color-sidebar-border);\n      border-radius: 6px;\n      padding: 8px 12px;\n      gap: 8px;\n      transition: all 0.2s ease;\n\n      &:focus-within {\n        border-color: var(--color-primary-green);\n        background: var(--color-menu-active-bg);\n      }\n\n      i {\n        color: var(--color-menu-label);\n        font-size: 0.9rem;\n        flex-shrink: 0;\n      }\n\n      input {\n        flex: 1;\n        background: transparent;\n        border: none;\n        color: var(--color-menu-text);\n        font-size: 16px !important;\n        outline: none;\n\n        &::placeholder {\n          color: var(--color-menu-label);\n        }\n      }\n    }\n  }\n\n  // Home menu item styling - above search box\n  .home-menu-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 12px;\n    margin: 8px;\n    border-radius: 6px;\n    text-decoration: none;\n    color: var(--color-menu-text);\n    font-weight: 500;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    position: relative;\n    border-bottom: 1px solid var(--color-sidebar-border);\n    -webkit-tap-highlight-color: transparent;\n    touch-action: manipulation;\n\n    i {\n      font-size: 1.1rem;\n      min-width: 20px;\n      text-align: center;\n      color: var(--color-icon-slate);\n      flex-shrink: 0;\n    }\n\n    .report-name {\n      font-size: 0.875rem;\n      color: var(--color-menu-text);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      flex: 1;\n    }\n\n    // Only apply hover effects on non-touch devices\n    @media (hover: hover) and (pointer: fine) {\n      &:hover {\n        background: var(--color-menu-hover-bg);\n        color: var(--color-menu-hover-text);\n\n        i, span {\n          color: var(--color-primary-green);\n        }\n\n        .report-name {\n          color: var(--color-primary-green);\n        }\n      }\n    }\n\n    &.active {\n      background: var(--color-menu-active-bg);\n      color: var(--color-menu-active-text);\n      border-left: 3px solid var(--color-menu-active-text);\n\n      i, span {\n        color: var(--color-menu-active-text);\n      }\n\n      .report-name {\n        color: var(--color-menu-active-text);\n      }\n\n      &:hover {\n        background: var(--color-menu-active-bg);\n      }\n    }\n  }\n\n  .reports-menu-items {\n    flex: 1;\n    overflow-y: auto;\n    padding: 8px;\n    transition: opacity 0.3s ease;\n\n    .reports-menu-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 10px 4px;\n      margin-bottom: 2px;\n      border-radius: 6px;\n      text-decoration: none;\n      color: var(--color-menu-text);\n      font-weight: 500;\n      transition: all 0.2s ease;\n      cursor: pointer;\n      position: relative;\n      -webkit-tap-highlight-color: transparent;\n      touch-action: manipulation;\n\n      // On mobile, create distinct click zones\n      @media (hover: none) or (pointer: coarse) {\n        padding-right: 4px; // Reduce right padding to make space for fav button\n      }\n\n      i {\n        font-size: 1.1rem;\n        min-width: 20px;\n        text-align: center;\n        color: var(--color-icon-slate);\n        flex-shrink: 0;\n        pointer-events: none; // Icon shouldn't block clicks\n      }\n\n      .report-name {\n        font-size: 0.875rem;\n        color: var(--color-menu-text);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        flex: 1;\n        pointer-events: none; // Text shouldn't block clicks\n        // On mobile, add right margin to avoid overlapping with fav button\n        @media (hover: none) or (pointer: coarse) {\n          margin-right: 4px;\n        }\n      }\n\n      .favorite-icon-btn {\n        background: transparent;\n        border: none;\n        padding: 4px 4px;\n        border-radius: 4px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        opacity: 0;\n        transition: all 0.2s ease;\n        margin-left: auto;\n        -webkit-tap-highlight-color: transparent;\n        touch-action: manipulation;\n        // Prevent click event from bubbling to parent\n        position: relative;\n        z-index: 2;\n        flex-shrink: 0;\n\n        i {\n          font-size: 0.95rem;\n          color: var(--color-menu-text);\n          min-width: auto;\n          pointer-events: none; // Prevent icon from interfering with button click\n        }\n\n        // Only show on hover for desktop\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background: rgba(209, 172, 114, 0.1);\n            opacity: 1;\n\n            i {\n              color: var(--color-primary-green);\n            }\n          }\n        }\n\n        // Always show on mobile/touch devices with better touch target\n        @media (hover: none) or (pointer: coarse) {\n          opacity: 1;\n          min-width: 30px; // Larger touch target\n          min-height: 30px; // Larger touch target\n          padding: 4px;\n          margin-right: -4px; // Align to edge\n          margin-left: 8px; // Space from report name\n          border-left: 1px solid rgba(209, 172, 114, 0.2); // Visual separator\n\n          i {\n            font-size: 1rem; // Slightly larger on mobile\n          }\n        }\n\n        &.favorite-active {\n          opacity: 1;\n\n          i {\n            color: #faca00;\n          }\n\n          @media (hover: hover) and (pointer: fine) {\n            &:hover {\n              background: rgba(209, 172, 114, 0.2);\n            }\n          }\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.5;\n        }\n      }\n\n      // Show favorite button on hover for desktop only\n      @media (hover: hover) and (pointer: fine) {\n        &:hover .favorite-icon-btn {\n          opacity: 1;\n        }\n      }\n\n      span {\n        font-size: 0.875rem;\n        color: var(--color-menu-text);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      // Only apply hover effects on non-touch devices\n      @media (hover: hover) and (pointer: fine) {\n        &:hover {\n          background: var(--color-menu-hover-bg);\n          color: var(--color-menu-hover-text);\n\n          i, span {\n            color: var(--color-primary-green);\n          }\n\n          .report-name {\n            color: var(--color-primary-green);\n          }\n        }\n      }\n\n      &.active {\n        background: var(--color-menu-active-bg);\n        color: var(--color-menu-active-text);\n        border-left: 3px solid var(--color-menu-active-text);\n\n        i, span {\n          color: var(--color-menu-active-text);\n        }\n\n        .report-name {\n          color: var(--color-menu-active-text);\n        }\n\n        &:hover {\n          background: var(--color-menu-active-bg);\n        }\n      }\n\n      // Report with pages - add actions container\n      &.has-pages {\n        .report-menu-actions {\n          display: flex;\n          align-items: center;\n          gap: 4px;\n          margin-left: auto;\n          flex-shrink: 0;\n        }\n\n        .expand-icon-btn {\n          background: transparent;\n          border: none;\n          padding: 4px 4px;\n          border-radius: 4px;\n          cursor: pointer;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: all 0.2s ease;\n          -webkit-tap-highlight-color: transparent;\n          touch-action: manipulation;\n\n          i {\n            font-size: 0.85rem;\n            color: var(--color-menu-text);\n            min-width: auto;\n          }\n\n          &:hover {\n            background: rgba(209, 172, 114, 0.1);\n\n            i {\n              color: var(--color-primary-green);\n            }\n          }\n        }\n      }\n    }\n\n    // Container for report with pages\n    .report-with-pages {\n      margin-bottom: 4px;\n    }\n\n    // Sub-pages list\n    .report-pages-list {\n      padding-left: 20px;\n      margin-top: 2px;\n      margin-bottom: 4px;\n      border-left: 2px solid rgba(209, 172, 114, 0.2);\n      margin-left: 20px;\n\n      .report-page-item {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        padding: 8px 12px;\n        border-radius: 4px;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        -webkit-tap-highlight-color: transparent;\n        touch-action: manipulation;\n\n        i {\n          font-size: 0.9rem;\n          min-width: 16px;\n          text-align: center;\n          color: #94a3b8;\n          flex-shrink: 0;\n        }\n\n        .page-name {\n          font-size: 0.82rem;\n          color: #94a3b8;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          flex: 1;\n        }\n\n        @media (hover: hover) and (pointer: fine) {\n          &:hover {\n            background: rgba(209, 172, 114, 0.1);\n\n            i, .page-name {\n              color: var(--color-primary-green);\n            }\n          }\n        }\n\n        &.active {\n          background: rgba(209, 172, 114, 0.15);\n\n          i, .page-name {\n            color: var(--color-primary-green);\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n\n  &.collapsed {\n    // Home menu item in collapsed state\n    .home-menu-item {\n      justify-content: center;\n      padding: 8px 8px;\n      margin: 5px 5px;\n      border-left: none;\n      position: relative;\n\n      &:hover {\n        transform: none;\n        background: var(--color-menu-hover-bg);\n      }\n\n      i {\n        font-size: 1.3rem;\n        margin: 0;\n      }\n\n      span:not(.tooltip-text) {\n        display: none;\n      }\n\n      .tooltip-text {\n        display: block;\n      }\n\n      &.active {\n        background: var(--color-menu-active-bg);\n        border-left: 3px solid var(--color-menu-active-text);\n\n        i {\n          color: var(--color-menu-active-text);\n        }\n      }\n    }\n\n    .reports-menu-items {\n      padding: 10px 5px;\n      opacity: 1 !important;\n      visibility: visible !important;\n      pointer-events: auto !important;\n\n      .reports-menu-item {\n        justify-content: center;\n        padding: 12px 8px;\n        margin-bottom: 8px;\n        border-left: none;\n        position: relative;\n\n        &:hover {\n          transform: none;\n          background: var(--color-menu-hover-bg);\n        }\n\n        i {\n          font-size: 1.3rem;\n          margin: 0;\n        }\n\n        // Hide all spans except tooltip-text (but keep flyout submenu content visible)\n        > span:not(.tooltip-text) {\n          display: none;\n        }\n\n        &.active {\n          background: var(--color-menu-active-bg);\n          border-left: 3px solid var(--color-menu-active-text);\n\n          i {\n            color: var(--color-menu-active-text);\n          }\n        }\n      }\n\n      // Hide sub-pages in collapsed mode (regular expanded list)\n      .report-pages-list {\n        display: none !important;\n      }\n\n      // Hide expand/collapse icons in collapsed mode\n      .report-with-pages {\n        .expand-icon-btn {\n          display: none !important;\n        }\n      }\n\n      // Flyout submenu for collapsed mode\n      .report-submenu-flyout {\n        display: none;\n        position: absolute;\n        left: 100%;\n        top: 0;\n        min-width: 200px;\n        background: var(--color-sidebar-bg);\n        border: 1px solid var(--color-sidebar-border);\n        border-radius: 6px;\n        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);\n        z-index: 1100;\n        margin-left: 0; // No gap\n        overflow: hidden;\n\n        // Create invisible bridge between icon and flyout using pseudo-element\n        &::before {\n          content: '';\n          position: absolute;\n          right: 100%; // Position to the left of flyout\n          top: 0;\n          width: 10px; // 10px wide bridge\n          height: 100%;\n          background: transparent; // Invisible\n        }\n\n        .submenu-header {\n          padding: 10px 16px;\n          background: transparent; // No background, inherit from flyout\n          border-bottom: 1px solid rgba(209, 172, 114, 0.15); // Subtle separator\n          font-weight: 600;\n          font-size: 0.875rem;\n          color: var(--color-primary-green); // Use accent color to distinguish\n        }\n\n        .submenu-pages {\n          max-height: 400px;\n          overflow-y: auto;\n\n          // Custom scrollbar styling to match app theme\n          &::-webkit-scrollbar {\n            width: 6px;\n          }\n\n          &::-webkit-scrollbar-track {\n            background: var(--color-sidebar-bg);\n            border-radius: 10px;\n          }\n\n          &::-webkit-scrollbar-thumb {\n            background: var(--color-primary-green);\n            border-radius: 10px;\n\n            &:hover {\n              background: var(--color-primary-orange);\n            }\n          }\n        }\n\n        .submenu-page-item {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          padding: 10px 16px;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          color: var(--color-menu-text);\n\n          i {\n            font-size: 0.9rem;\n            color: #94a3b8;\n            min-width: 16px;\n          }\n\n          span {\n            font-size: 0.875rem;\n            white-space: nowrap;\n          }\n\n          &:hover {\n            background: var(--color-menu-hover-bg);\n\n            i, span {\n              color: var(--color-primary-green);\n            }\n          }\n\n          &.active {\n            background: rgba(209, 172, 114, 0.15);\n\n            i, span {\n              color: var(--color-primary-green);\n              font-weight: 600;\n            }\n          }\n        }\n      }\n\n      // Show flyout on hover - use report-with-pages container so hover works on both icon and flyout\n      .report-with-pages:hover {\n        .report-submenu-flyout {\n          display: block;\n        }\n      }\n    }\n  }\n\n  .favorites-section {\n    margin-bottom: 20px;\n    padding-bottom: 15px;\n    border-bottom: 1px solid var(--color-sidebar-border);\n\n    .favorites-header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 10px 12px;\n      margin-bottom: 10px;\n      color: var(--color-menu-label);\n      font-size: 0.75rem;\n      font-weight: 600;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n\n      i {\n        color: var(--color-primary-green);\n        font-size: 0.875rem;\n      }\n\n      .favorites-count {\n        margin-left: auto;\n        background: var(--color-sidebar-border);\n        color: var(--color-menu-text);\n        padding: 2px 8px;\n        border-radius: 12px;\n        font-size: 0.7rem;\n      }\n    }\n\n    .favorite-report-card {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 12px;\n      margin-bottom: 8px;\n      background: var(--color-sidebar-bg);\n      border: 1px solid var(--color-sidebar-border);\n      border-radius: 8px;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &:hover {\n        background: var(--color-menu-hover-bg);\n        border-color: var(--color-primary-green);\n        transform: translateY(-2px);\n        box-shadow: 0 4px 8px rgba(209, 172, 114, 0.15);\n      }\n\n      &.active {\n        background: var(--color-menu-active-bg);\n        border-color: var(--color-primary-green);\n        border-left: 3px solid var(--color-menu-active-text);\n\n        .favorite-report-name {\n          color: var(--color-menu-active-text);\n        }\n      }\n\n      .favorite-report-icon {\n        width: 40px;\n        height: 40px;\n        background: var(--color-primary-green);\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n\n        i {\n          color: var(--color-text-dark);\n          font-size: 1.1rem;\n        }\n      }\n\n      .favorite-report-info {\n        flex: 1;\n        min-width: 0;\n\n        .favorite-report-name {\n          margin: 0 0 4px 0;\n          font-size: 0.875rem;\n          font-weight: 600;\n          color: var(--color-menu-text);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n\n        .favorite-report-description {\n          margin: 0;\n          font-size: 0.75rem;\n          color: var(--color-menu-label);\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n      .favorite-star {\n        flex-shrink: 0;\n\n        i {\n          color: var(--color-primary-green);\n          font-size: 1rem;\n        }\n      }\n    }\n  }\n\n  .all-reports-header {\n    padding: 10px 12px;\n    margin-bottom: 5px;\n    color: var(--color-menu-label);\n    font-size: 0.75rem;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n  }\n\n  .reports-menu-items::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  .reports-menu-items::-webkit-scrollbar-track {\n    background: var(--color-sidebar-bg);\n    border-radius: 10px;\n  }\n\n  .reports-menu-items::-webkit-scrollbar-thumb {\n    background: var(--color-primary-green);\n    border-radius: 10px;\n\n    &:hover {\n      background: var(--color-primary-orange);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .reports-menu {\n    width: 100% !important;\n    height: calc(100vh - 55px);\n    position: fixed !important;\n    top: 45px !important;\n    left: 0 !important;\n    max-height: calc(100vh - 55px);\n    overflow: hidden;\n    border-right: none;\n    border-bottom: none;\n    z-index: 1000;\n    padding-top: 0 !important;\n    box-shadow: none;\n    display: flex;\n    flex-direction: column;\n\n    &.collapsed {\n      display: none !important;\n    }\n\n    .reports-menu-brand {\n      padding: 10px;\n      flex-shrink: 0; // Don't let this shrink\n\n      .company-logo {\n        width: 30px;\n        height: 30px;\n      }\n\n      .company-name {\n        font-size: 0.9rem;\n      }\n    }\n\n    .reports-menu-header {\n      padding: 10px 15px;\n      flex-shrink: 0; // Don't let this shrink\n\n      h5 {\n        font-size: 0.65rem;\n      }\n    }\n\n    .reports-menu-controls {\n      padding: 10px;\n      flex-shrink: 0; // Don't let this shrink\n\n      .search-box {\n        padding: 6px 10px;\n        font-size: 0.8rem;\n      }\n    }\n\n    .reports-menu-items {\n      padding: 5px;\n      padding-bottom: 20px; // Extra space at bottom to ensure last items are visible\n      flex: 1 1 auto;\n      overflow-y: auto !important;\n      min-height: 0; // Critical: allows flex child to shrink below content size\n      max-height: none !important;\n      -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n\n      .reports-menu-item {\n        padding: 10px;\n        font-size: 0.9rem;\n        flex-shrink: 0; // Prevent items from shrinking\n\n        i {\n          font-size: 1.1rem;\n        }\n      }\n\n      // Ensure sub-pages don't break scrolling\n      .report-pages-list {\n        max-height: none;\n        flex-shrink: 0; // Prevent sub-pages from shrinking\n      }\n    }\n  }\n  .profile-section-bottom {\n    display:none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
